import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

const AccountCard = ({
  title,
  action,
  headerContent,
  hideDivider = false,
  children,
  classes,
}) => (
  <Box className={classes.card}>
    <Box
      className={
        headerContent ? classes.cardHeaderWithSearch : classes.cardHeader
      }
    >
      {headerContent ? (
        <>
          <Box className={classes.cardHeaderTitleRow}>
            <Typography className={classes.cardTitle}>{title}</Typography>
            {action}
          </Box>
          <Box className={classes.cardHeaderFilterRow}>{headerContent}</Box>
        </>
      ) : (
        <>
          <Typography className={classes.cardTitle}>{title}</Typography>
          {action}
        </>
      )}
    </Box>
    {!hideDivider ? <Box className={classes.cardDivider} /> : null}
    <Box className={classes.cardContent}>{children}</Box>
  </Box>
)

export default AccountCard
